import { render, staticRenderFns } from "./BackgroundSettings.vue?vue&type=template&id=c49b2e00&scoped=true"
import script from "./BackgroundSettings.vue?vue&type=script&lang=js"
export * from "./BackgroundSettings.vue?vue&type=script&lang=js"
import style0 from "./BackgroundSettings.vue?vue&type=style&index=0&id=c49b2e00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49b2e00",
  null
  
)

export default component.exports